module.exports = __webpack_public_path__ + "img/wiresk.21446e29.png";